const wasteCalculatorPageMessages = {
  WASTE_CALCULATOR_PAGE: {
    TITLE: 'Waste & Abuse',
    SUB_TITLE: 'Track the amount of waste generated by the healthcare system',
    FOR: 'for',
    COHORT_MEMBERS: 'Cohort Members',
    COHORT_COST: 'Cohort Cost',
    COHORT_CLAIMS: 'Cohort Claims',
    CARD: {
      SUB_TITLE: 'Click on a category to view more info',
      LABELS: ['Members', 'Cost', 'Claims'],
    },
    TABLE_HEADERS: [
      'Wastage Factors',
      'Total Cost',
      'Avg Cost',
      'Members',
      'Claims',
    ],
    RECOMMENDATIONS_TAB: {
      TITLE: 'Waste Calculator',
    },
  },
};

export default wasteCalculatorPageMessages;
